import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MadeByFilter',
  props: {
  searchParams: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



const tokenName = computed({
  get: () => __props.searchParams['token.name'] ?? null,
  set: (newValue) => {
    if (newValue) {
      __props.searchParams['token.name'] = newValue;

      return;
    }
    delete __props.searchParams['token.name'];
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.$t('Наименование клиента')), 1 /* TEXT */),
    _createVNode(_component_v_text_field, {
      modelValue: tokenName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tokenName).value = $event)),
      placeholder: _ctx.$t('Поиск по наименованию клиента API'),
      "single-line": "",
      "hide-details": "",
      variant: "solo"
    }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
  ]))
}
}

})